import { createSlice } from '@reduxjs/toolkit'

export const propertiesPageSlice = createSlice({
  name: 'propertiesPageState',
  initialState: {
    filtersProperties: {
      page: 1,
      searchWord: '',
      hasDataOnly: false,
      isValidatedOnly: false,
    },
    propertiesList: [],
  },
  reducers: {
    updateFilters: (state, action) => {
      state.filtersProperties = action.payload
    },
    updatePropertiesList: (state, action) => {
      state.propertiesList = Array.isArray(action.payload) ? action.payload : []
    },
    resetStatePropertiesPage: (state) => {
      state.filtersProperties = {
        page: 1,
        searchWord: '',
        hasDataOnly: false,
        isValidatedOnly: false,
      }
      state.propertiesList = []
    },
  },
})

export const { updateFilters, updatePropertiesList, resetStatePropertiesPage } = propertiesPageSlice.actions
export default propertiesPageSlice.reducer
